import { render } from "./RoomSpiderweb.vue?vue&type=template&id=043a155e&ts=true"
import script from "./RoomSpiderweb.vue?vue&type=script&lang=ts"
export * from "./RoomSpiderweb.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__